module.exports = __webpack_public_path__ + "img/filter-details1.7001da5a.png";